import { Box, Stack } from "@mui/material";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIdentity } from "../../containers/IdentityContainer";
import { scrollSx } from "../../utils";
import { SideDrawer } from "./SideDrawer";

interface NavProps {
  children: React.ReactNode;
}

export const Nav: React.FC<NavProps> = ({ children }) => {
  const { isLoggedIn, airplxIdentity } = useIdentity();
  const [open, setOpen] = React.useState<boolean>(false);
  const navigate = useNavigate();

  const location = useLocation();
  const isMultiHangar = location.pathname.includes("/multi-hangar/");
  const isTVMode = location.pathname.includes("/tv"); // Detect TV mode

  const handleClickRoute = (pathname: string) => {
    navigate(pathname);
  };

  return (
    <Stack
      direction="row"
      display="flex"
      height="100%"
      sx={{ overflow: "hidden" }}
    >
      {/* Hide sidebar in TV mode */}
      {!isTVMode && (
        <Box sx={{ height: "100%", maxWidth: "100%" }}>
          {isLoggedIn ? (
            <SideDrawer
              open={open}
              setOpen={setOpen}
              onClickRoute={handleClickRoute}
              showAdmin={airplxIdentity?.isadmin || false}
            />
          ) : null}
        </Box>
      )}
      <Box
        component="main"
        sx={{
          height: "100%",
          width: "100%",
          overflow: isMultiHangar ? "scroll" : "auto",
          ...(isMultiHangar ? scrollSx : {}),
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};
